export interface AlacakRecord {
  id: number;
  adSoyad: string;
  telefon: string;
  toplamBorc: number;
  odenenTutar: number;
  kalanTutar: number;
  odemeTarihi: string;
  durum: "Bekliyor" | "Yaklaştı" | "Gecikti" | "Ödendi";
  not: string;
}

export const alacaklarData: AlacakRecord[] = [
  {
    id: 1,
    adSoyad: "Ahmet Yılmaz",
    telefon: "+90 555 123 4567",
    toplamBorc: 25000,
    odenenTutar: 12500,
    kalanTutar: 12500,
    odemeTarihi: "2026-05-01",
    durum: "Gecikti",
    not: "Kalan ödeme için hatırlatma gönderildi.",
  },
  {
    id: 2,
    adSoyad: "Fatma Kaya",
    telefon: "+90 555 234 5678",
    toplamBorc: 15000,
    odenenTutar: 6100,
    kalanTutar: 8900,
    odemeTarihi: "2026-05-01",
    durum: "Gecikti",
    not: "2. taksit ödemesi bekleniyor.",
  },
  {
    id: 3,
    adSoyad: "Mehmet Demir",
    telefon: "+90 555 345 6789",
    toplamBorc: 30000,
    odenenTutar: 15000,
    kalanTutar: 15000,
    odemeTarihi: "2026-05-03",
    durum: "Yaklaştı",
    not: "Altın bilezik siparişi kalan ödemesi.",
  },
  {
    id: 4,
    adSoyad: "Ayşe Çelik",
    telefon: "+90 555 456 7890",
    toplamBorc: 12000,
    odenenTutar: 5300,
    kalanTutar: 6700,
    odemeTarihi: "2026-05-04",
    durum: "Yaklaştı",
    not: "Küpe siparişi için peşinat alındı.",
  },
  {
    id: 5,
    adSoyad: "Hasan Şahin",
    telefon: "+90 555 567 8901",
    toplamBorc: 35000,
    odenenTutar: 14000,
    kalanTutar: 21000,
    odemeTarihi: "2026-05-02",
    durum: "Yaklaştı",
    not: "Alyans seti siparişi.",
  },
  {
    id: 6,
    adSoyad: "Elif Arslan",
    telefon: "+90 555 678 9012",
    toplamBorc: 8000,
    odenenTutar: 0,
    kalanTutar: 8000,
    odemeTarihi: "2026-05-10",
    durum: "Bekliyor",
    not: "Yeni müşteri, ilk alışveriş.",
  },
  {
    id: 7,
    adSoyad: "Kemal Öztürk",
    telefon: "+90 555 789 0123",
    toplamBorc: 45000,
    odenenTutar: 45000,
    kalanTutar: 0,
    odemeTarihi: "2026-04-28",
    durum: "Ödendi",
    not: "Tamamlandı, teslim edildi.",
  },
  {
    id: 8,
    adSoyad: "Sibel Yıldırım",
    telefon: "+90 555 890 1234",
    toplamBorc: 18500,
    odenenTutar: 10000,
    kalanTutar: 8500,
    odemeTarihi: "2026-05-07",
    durum: "Bekliyor",
    not: "Gümüş kolye ve bileklik seti.",
  },
  {
    id: 9,
    adSoyad: "Murat Aydın",
    telefon: "+90 555 901 2345",
    toplamBorc: 22000,
    odenenTutar: 22000,
    kalanTutar: 0,
    odemeTarihi: "2026-04-25",
    durum: "Ödendi",
    not: "Düğün seti tamamlandı.",
  },
  {
    id: 10,
    adSoyad: "Deniz Karaca",
    telefon: "+90 555 012 3456",
    toplamBorc: 9500,
    odenenTutar: 0,
    kalanTutar: 9500,
    odemeTarihi: "2026-05-06",
    durum: "Bekliyor",
    not: "Yüzük boyutu düzeltme işi.",
  },
];